import UpdateProfileContainer from 'modules/profiles/containers/UpdateProfileContainer';

const UpdateProfileView = props => <UpdateProfileContainer {...props} />;

export default UpdateProfileView;
